import { useState } from 'react';
import { useSearchParams, createSearchParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
var moment = require('moment');


export function Loader() {
	return (
		<div className="flex text-center h-full justify-center items-center">
			<div role="status">
				<svg aria-hidden="true" className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
					<path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
				</svg>
				<span className="sr-only">Loading...</span>
			</div>
		</div>
	)
}

export function ButtonCategory(props) {
	return (
		<button
			type="button"
			onClick={props.onClick}
			className={`p-3 rounded max-w-36 text-white ${props.active ? 'bg-gray-800' : 'bg-gray-500 hover:bg-gray-800'}`}>
			{props.item}
		</button>
	)
}

export function SubmitButton(props) {
	return (
		<input
			form={props.form}
			type="submit"
			className={`p-2 rounded max-w-36 text-white cursor-pointer ${props.active ? 'bg-red-800' : 'bg-red-500 hover:bg-red-800'}`}
			value={props.label}
			disabled={props.disabled}
		/>
	)
}

export function MainButton(props) {
	return (
		<button
			type={props.type ? props.type : 'button'}
			onClick={props.onClick}
			disabled={props.disabled}
			className={`p-2 rounded max-w-36 text-white ${props.active ? 'bg-red-800' : 'bg-red-500 hover:bg-red-800'} disabled:bg-gray-500`}>
			{props.label}
		</button>
	)
}

export function SecondaryButton(props) {
	return (
		<button
			type={props.type ? props.type : 'button'}
			onClick={props.onClick}
			disabled={props.disabled}
			className={`p-2 rounded max-w-36 text-white ${props.active ? 'bg-green-800' : 'bg-green-500 hover:bg-green-800'}`}>
			{props.label}
		</button>
	)
}

export function Pagination(props) {
	let [ searchParams, setSearchParams ] = useSearchParams()
	
	var pageList = [];
	const current_page = parseInt(searchParams.get('page')) ? parseInt(searchParams.get('page')) : 1
	const min_page = (current_page - 2) > 1 ? (current_page - 2) : 1

	for (var i = min_page; i <= props.pages; i++) {
		pageList.push(i);
	}
	
	const start = (current_page - 1) * props.perPage + 1
	const end = current_page * props.perPage

	function getPageUrl(page) {
		let params = {}
		for (const x of searchParams.keys()){
			params[x] = searchParams.get(x)
		}

		params['page'] = page
		return `./?${createSearchParams(params).toString()}`
	}

	return (
		<div className="flex items-center justify-between bg-white py-3">
			<div className="md:flex md:flex-1 md:items-center md:justify-between">
				<div className="mb-5">
					<p className="text-sm text-gray-700">
						Showing <span className="font-medium">{ start }</span> to <span className="font-medium">{ end }</span> of <span className="font-medium">{ props.total }</span> results
					</p>
				</div>
				<div className="mb-5">
					<nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
						<a href={`./?type=${searchParams.get('type')}&page=1`} 
							className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20">
								<span className="sr-only">First</span>
								<FontAwesomeIcon icon={faAngleLeft} className="h-5 w-5" aria-hidden="true" />
						</a>
						
						{pageList.splice(0, 5).map(item => {
							return (
								<a key={item.toString()} href={getPageUrl(item)} 
									aria-current="page" 
									className={item === current_page ? 
										"relative z-10 inline-flex items-center border border-indigo-500 bg-indigo-50 px-4 py-2 text-sm font-medium text-indigo-600 focus:z-20"
										:"relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
									}>
									{ item }
								</a>
							)
						})}
						
						<a href={getPageUrl(props.pages)} 
							className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20">
								<span className="sr-only">Last</span>
								<FontAwesomeIcon icon={faAngleRight} className="h-5 w-5" aria-hidden="true" />
						</a>
					</nav>
				</div>
			</div>
		</div>
	)
}

export function statusTag(value) {
	const statusMap = {
		'DONE': 'inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 ring-1 ring-inset ring-green-500/20',
		'CANCEL': 'inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10',
		'PENDING': 'inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-yellow-600 ring-1 ring-inset ring-yellow-500/10',
	}

	return <div className={statusMap[value]}>{value}</div>
}

export function FileInput(props) {
	return (
		<div className="form-group">
			{props.label?
				<div className="form-label text-sm text-gray-500 mb-1">{props.label}</div>
			: null}

			<div className="form-styling">				
				<input 
                    className="block w-full p-1 border rounded text-sm"
					type="file" 
					name={props.name} 
					placeholder={props.placeholder}
					required={props.required}
					onChange={props.onChange} 
					value={props.value} 
					maxLength={props.maxLength} 
					minLength={props.minLength}
					disabled={props.disabled} />
			</div>
		</div>
	)
}

export function TextInput(props) {
	return (
		<div className="form-group">
			{props.label?
				<div className="form-label text-sm text-gray-500 mb-1">{props.label}</div>
			: null}

			<div className="form-styling">				
				<input 
                    className="block w-full p-1 border rounded text-sm"
					type="text" 
					name={props.name} 
					placeholder={props.placeholder}
					required={props.required}
					onChange={props.onChange} 
					value={props.value || ''} 
					maxLength={props.maxLength} 
					minLength={props.minLength}
					disabled={props.disabled} />
			</div>
		</div>
	)
}


export function TextArea(props) {
	return (
		<div className="form-group">
			{props.label?
				<div className="form-label text-sm text-gray-500 mb-1">{props.label}</div>
			: null}

			<div className="form-styling">				
				<textarea 
                    className="block w-full p-1 border rounded text-sm"
					type="text" 
					name={props.name} 
					placeholder={props.placeholder}
					required={props.required}
					onChange={props.onChange} 
					value={props.value} 
					maxLength={props.maxLength} 
					minLength={props.minLength}
					disabled={props.disabled} 
					rows={props.rows} />
			</div>
		</div>
	)
}

export function DateInput(props) {
	const [selectedDate, setSelectedDate] = useState(new Date())
	const maxDate = new Date(props.maxDate);
	const minDate = new Date(props.minDate);

	function update(date) {
		setSelectedDate(date)
		props.onChange({'target': {'name': props.name, 'value': date && moment(date).format('YYYY-MM-DD')}})
	}

	function checkInitial(initial) {
		const initial_date = new Date(moment(initial))
		
		if (initial_date > maxDate || initial_date < minDate) {
			return ''
		}

		return initial
	}

	return (
		<div className="form-group">
			{props.label?
				<div className="form-label text-sm text-gray-500 mb-1">{props.label}</div>
			: null}

			<div className="form-styling">	
				<DatePicker
					className="block w-full p-1 border rounded text-sm"
					name={props.name}
					required={props.required}
					selected={selectedDate} 
					value={checkInitial(props.value)}
					onChange={(date) => update(date)}
					dateFormat="yyyy-MM-dd" 
					dateFormatCalendar="MMM Y"
					minDate={minDate}
					maxDate={maxDate}
					showYearDropdown
					yearDropdownItemNumber={5}
					showMonthDropdown
					dropdownMode="select"
					fixedHeight
					disabled={props.disabled}
				/>
			</div>
		</div>
	)
}

export function CheckListInput(props) {
	return (
		<div className="flex">
			<div className="flex-initial self-center w-5">
				<input 
					id={props.name} 
					type="checkbox" 
					required={props.required}
					name={props.name} 
					value={props.value} 
					onChange={props.onChange} />
			</div>
			<div className="flex-1 self-center">
				<label for={props.name}>{props.text}</label>
			</div>
		</div>
	)
}

export function EmailInput(props) {
	return (
		<div className="form-group">	
			{props.label?
				<div className="form-label text-sm text-gray-500 mb-1">{props.label}</div>
			: null}

			<div className="form-styling">	
				<input 
					className="block w-full p-1 border rounded text-sm"
					type="email" 
					name={props.name} 
					required={props.required}
					onChange={props.onChange} 
					value={props.value}
					disabled={props.disabled} />
				</div>
		</div>
	)
}

export function SelectInput(props) {
	return (
		<div className="form-group">	
			{props.label?
				<div className="form-label text-sm text-gray-500 mb-1">{props.label}</div>
			: null}

			<div className="form-styling">	
				<select 
					className="block w-full p-1 border rounded text-sm" 
					name={props.name} 
					required={props.required}
					onChange={props.onChange} 
					value={props.value || ''}
					disabled={props.disabled}>
						<option key='' value=''>-- All {props.label} --</option>

						{props.data ?
							props.data.map(item => {
								return(
									<option key={item.key} value={item.key}>{item.value}</option>
								)
							})
						: null}
				</select>
			</div>
		</div>
	)
}

export function PageHeader(props) {
	return (
		<div className="bg-white rounded px-5 py-3 mb-5">
			<div className="grid grid-cols-2">
				<h1 className="text-2xl text-gray-500 font-bold self-center">{props.text}</h1>

				{localStorage.getItem('client_logo') !== 'null' ?
					<img className="max-h-10 justify-self-end" src={localStorage.getItem('client_logo')} />
				: null}
			</div>
		</div>
	)
}
